import type { Contact as BaseContact } from '@mes-amis/super-form';

/**
 * Client Contact Type - extends the shared package type with app-specific fields.
 * Contacts can be caregivers, emergency contacts, legal representatives, etc.
 */
export interface Contact extends Omit<BaseContact, 'address'> {
  organization_id?: number; // Organization scope for data isolation
  address?: {
    address_line1?: string;
    address_line2?: string | null;
    city?: string;
    state?: string;
    county?: string | null;
    zip?: string;
  } | null;
}

/**
 * Get a human-readable list of roles for a contact
 */
export function getContactRoles(contact: Contact): string[] {
  const roles: string[] = [];

  if (contact.designated) roles.push('Proxy');
  if (contact.physician) roles.push('Physician');
  if (contact.caregiver) roles.push('Caregiver');
  if (contact.legal_representative) roles.push('Legal Representative');
  if (contact.emergency) roles.push('Emergency Contact');

  return roles;
}

/**
 * Get a formatted string of roles
 */
export function formatContactRoles(contact: Contact): string {
  return getContactRoles(contact).join(', ');
}
